import { t as e } from "./utils-DQJjwn-K.js";
import * as t from "react";
import { AlertCircle as n, ChevronRight as r, Loader2 as i } from "lucide-react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { Slot as s } from "@radix-ui/react-slot";
import { cva as c } from "class-variance-authority";
//#region src/design-system/primitives/stack.tsx
var l = c("flex", {
	variants: {
		direction: {
			vertical: "flex-col",
			horizontal: "flex-row"
		},
		gap: {
			0: "gap-0",
			1: "gap-1",
			2: "gap-2",
			3: "gap-3",
			4: "gap-4",
			5: "gap-5",
			6: "gap-6",
			8: "gap-8",
			10: "gap-10",
			12: "gap-12",
			16: "gap-16",
			inline: "gap-(--spacing-inline)",
			stack: "gap-(--spacing-stack)",
			"stack-lg": "gap-(--spacing-stack-lg)"
		},
		align: {
			start: "items-start",
			center: "items-center",
			end: "items-end",
			stretch: "items-stretch",
			baseline: "items-baseline"
		},
		justify: {
			start: "justify-start",
			center: "justify-center",
			end: "justify-end",
			between: "justify-between",
			around: "justify-around",
			evenly: "justify-evenly"
		},
		wrap: {
			true: "flex-wrap",
			false: "flex-nowrap"
		}
	},
	defaultVariants: {
		direction: "vertical",
		gap: 4,
		align: "stretch",
		justify: "start",
		wrap: !1
	}
}), u = t.forwardRef(({ className: t, direction: n, gap: r, align: i, justify: o, wrap: c, isAsChild: u = !1, ...d }, f) => /* @__PURE__ */ a(u ? s : "div", {
	className: e(l({
		direction: n,
		gap: r,
		align: i,
		justify: o,
		wrap: c,
		className: t
	})),
	ref: f,
	...d
}));
u.displayName = "Stack";
//#endregion
//#region src/design-system/primitives/grid.tsx
var d = c("grid", {
	variants: {
		columns: {
			1: "grid-cols-1",
			2: "grid-cols-2",
			3: "grid-cols-3",
			4: "grid-cols-4",
			5: "grid-cols-5",
			6: "grid-cols-6",
			7: "grid-cols-7",
			8: "grid-cols-8",
			9: "grid-cols-9",
			10: "grid-cols-10",
			11: "grid-cols-11",
			12: "grid-cols-12"
		},
		gap: {
			0: "gap-0",
			1: "gap-1",
			2: "gap-2",
			3: "gap-3",
			4: "gap-4",
			5: "gap-5",
			6: "gap-6",
			8: "gap-8",
			10: "gap-10",
			12: "gap-12",
			16: "gap-16"
		},
		align: {
			start: "items-start",
			center: "items-center",
			end: "items-end",
			stretch: "items-stretch"
		},
		justify: {
			start: "justify-items-start",
			center: "justify-items-center",
			end: "justify-items-end",
			stretch: "justify-items-stretch"
		}
	},
	defaultVariants: {
		columns: 1,
		gap: 4,
		align: "stretch",
		justify: "start"
	}
}), f = t.forwardRef(({ className: t, columns: n, gap: r, align: i, justify: o, isAsChild: c = !1, ...l }, u) => /* @__PURE__ */ a(c ? s : "div", {
	className: e(d({
		columns: n,
		gap: r,
		align: i,
		justify: o,
		className: t
	})),
	ref: u,
	...l
}));
f.displayName = "Grid";
//#endregion
//#region src/design-system/components/text.tsx
var p = c("", {
	variants: {
		variant: {
			body: "text-[length:var(--text-body-size)] leading-[var(--text-body-lh)]",
			caption: "text-[length:var(--text-caption-size)] leading-[var(--text-caption-lh)]",
			detail: "text-[length:var(--text-detail-size)] leading-[var(--text-detail-lh)]",
			overline: "text-[length:var(--text-detail-size)] leading-[var(--text-detail-lh)] uppercase tracking-wide"
		},
		weight: {
			normal: "font-normal",
			medium: "font-medium",
			semibold: "font-semibold",
			bold: "font-bold"
		},
		color: {
			foreground: "text-foreground",
			muted: "text-muted-foreground",
			primary: "text-primary",
			secondary: "text-secondary",
			destructive: "text-destructive",
			success: "text-success",
			info: "text-info"
		}
	},
	defaultVariants: {
		variant: "body",
		weight: "normal",
		color: "foreground"
	}
}), m = t.forwardRef(({ as: t = "p", isAsChild: n = !1, className: r, variant: i, weight: o, color: c, ...l }, u) => /* @__PURE__ */ a(n ? s : t, {
	className: e(p({
		variant: i,
		weight: o,
		color: c,
		className: r
	})),
	ref: u,
	...l
}));
m.displayName = "Text";
//#endregion
//#region src/design-system/components/heading.tsx
var h = c("font-heading", {
	variants: {
		size: {
			"5xl": "text-[length:var(--heading-5xl-size)] leading-[var(--heading-5xl-lh)] tracking-tight",
			"4xl": "text-[length:var(--heading-4xl-size)] leading-[var(--heading-4xl-lh)] tracking-tight",
			"3xl": "text-[length:var(--heading-3xl-size)] leading-[var(--heading-3xl-lh)] tracking-tight",
			"2xl": "text-[length:var(--heading-2xl-size)] leading-[var(--heading-2xl-lh)]",
			xl: "text-[length:var(--heading-xl-size)] leading-[var(--heading-xl-lh)]",
			lg: "text-[length:var(--heading-lg-size)] leading-[var(--heading-lg-lh)]",
			base: "text-[length:var(--heading-base-size)] leading-[var(--heading-base-lh)]",
			sm: "text-[length:var(--heading-sm-size)] leading-[var(--heading-sm-lh)]"
		},
		color: {
			foreground: "text-foreground",
			muted: "text-muted-foreground",
			primary: "text-primary"
		},
		responsive: {
			true: "",
			false: ""
		}
	},
	compoundVariants: [
		{
			size: "5xl",
			responsive: !0,
			className: "text-[length:var(--heading-3xl-size)] leading-[var(--heading-3xl-lh)] md:text-[length:var(--heading-4xl-size)] md:leading-[var(--heading-4xl-lh)] lg:text-[length:var(--heading-5xl-size)] lg:leading-[var(--heading-5xl-lh)]"
		},
		{
			size: "4xl",
			responsive: !0,
			className: "text-[length:var(--heading-2xl-size)] leading-[var(--heading-2xl-lh)] md:text-[length:var(--heading-3xl-size)] md:leading-[var(--heading-3xl-lh)] lg:text-[length:var(--heading-4xl-size)] lg:leading-[var(--heading-4xl-lh)]"
		},
		{
			size: "3xl",
			responsive: !0,
			className: "text-[length:var(--heading-xl-size)] leading-[var(--heading-xl-lh)] md:text-[length:var(--heading-2xl-size)] md:leading-[var(--heading-2xl-lh)] lg:text-[length:var(--heading-3xl-size)] lg:leading-[var(--heading-3xl-lh)]"
		}
	],
	defaultVariants: {
		size: "2xl",
		color: "foreground",
		responsive: !1
	}
}), g = t.forwardRef(({ level: t = "h2", isAsChild: n = !1, className: r, size: i, color: o, responsive: c, ...l }, u) => /* @__PURE__ */ a(n ? s : t, {
	className: e(h({
		size: i,
		color: o,
		responsive: c,
		className: r
	})),
	ref: u,
	...l
}));
g.displayName = "Heading";
//#endregion
//#region src/design-system/components/empty-state.tsx
function _({ icon: t, title: n, description: r, action: i, className: s }) {
	return /* @__PURE__ */ a("div", {
		className: e("flex h-full items-center justify-center", s),
		children: /* @__PURE__ */ o(u, {
			gap: 2,
			align: "center",
			className: "text-center text-muted-foreground",
			children: [
				t,
				/* @__PURE__ */ a(m, {
					variant: "caption",
					children: n
				}),
				r && /* @__PURE__ */ a(m, {
					variant: "detail",
					color: "muted",
					children: r
				}),
				i
			]
		})
	});
}
_.displayName = "EmptyState";
//#endregion
//#region src/design-system/components/status-message.tsx
function v({ variant: t, icon: n, title: r, description: s, className: c }) {
	let l = n ?? (t === "loading" ? /* @__PURE__ */ a(i, { className: "h-8 w-8 animate-spin text-primary" }) : void 0);
	return /* @__PURE__ */ a("div", {
		className: e("flex h-full items-center justify-center", c),
		children: /* @__PURE__ */ o(u, {
			gap: 2,
			align: "center",
			className: "text-center",
			children: [
				l,
				r && /* @__PURE__ */ a(m, {
					variant: "caption",
					weight: t === "error" ? "medium" : void 0,
					color: t === "error" ? "destructive" : "muted",
					children: r
				}),
				s && /* @__PURE__ */ a(m, {
					variant: "caption",
					color: "muted",
					children: s
				})
			]
		})
	});
}
v.displayName = "StatusMessage";
//#endregion
//#region src/design-system/components/error-message.tsx
function y({ title: t, description: i, details: s, detailsSummary: c, action: l, icon: u, className: d }) {
	return /* @__PURE__ */ a("div", {
		className: e("flex w-full items-center justify-center p-6", d),
		children: /* @__PURE__ */ o("div", {
			role: "alert",
			"aria-live": "assertive",
			className: "w-full max-w-3xl rounded-xl border border-border bg-card p-4 shadow-sm sm:p-5",
			children: [
				/* @__PURE__ */ o("div", {
					className: "flex items-start gap-3",
					children: [/* @__PURE__ */ a("div", {
						className: "rounded-full bg-destructive/10 p-2.5",
						children: u ?? /* @__PURE__ */ a(n, { className: "h-6 w-6 text-destructive" })
					}), /* @__PURE__ */ o("div", {
						className: "min-w-0",
						children: [/* @__PURE__ */ a(m, {
							as: "h3",
							variant: "body",
							weight: "semibold",
							children: t
						}), i && /* @__PURE__ */ a(m, {
							variant: "caption",
							color: "muted",
							className: "mt-1",
							children: i
						})]
					})]
				}),
				s && /* @__PURE__ */ o("details", {
					className: "group mt-4",
					children: [/* @__PURE__ */ o("summary", {
						className: e("flex cursor-pointer list-none items-center gap-2 rounded-lg border border-border", "bg-muted/25 px-3 py-2 hover:bg-muted/40"),
						children: [/* @__PURE__ */ a(r, { className: "h-4 w-4 shrink-0 text-muted-foreground transition-transform group-open:rotate-90" }), /* @__PURE__ */ a(m, {
							as: "span",
							variant: "caption",
							color: "muted",
							weight: "medium",
							children: c || "Show technical details"
						})]
					}), /* @__PURE__ */ a("div", {
						className: "mt-2 rounded-lg border border-border bg-muted/40 p-4",
						children: /* @__PURE__ */ a(m, {
							variant: "caption",
							color: "muted",
							className: "whitespace-pre-wrap",
							children: s
						})
					})]
				}),
				l && /* @__PURE__ */ a("div", {
					className: "mt-4",
					children: l
				})
			]
		})
	});
}
y.displayName = "ErrorMessage";
//#endregion
//#region src/design-system/components/section-header.tsx
function b({ children: t, className: n, hasNoBorder: r }) {
	return /* @__PURE__ */ a("div", {
		className: e("flex h-(--header-height) shrink-0 items-center px-(--spacing-section)", !r && "border-b border-border", n),
		children: t
	});
}
//#endregion
export { g as a, u as c, _ as i, y as n, m as o, v as r, f as s, b as t };

//# sourceMappingURL=design-system-B26cLg1l.js.map